function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from "react";
import injectSectionElements from "../injectSectionElements";
class RepeatedItem extends Component {
  render() {
    const {
      Component: ItemComponent,
      values,
      Elements,
      number,
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement(ItemComponent, _extends({
      classes: classes,
      number: number,
      Elements: Elements
    }, values));
  }
}
const RepeatedItemWithElements = injectSectionElements(RepeatedItem);
const RepeatedItems = ({
  classes,
  Component: ItemComponent,
  value
}) => value.map((current, index) => /*#__PURE__*/React.createElement(RepeatedItemWithElements, {
  key: index,
  number: index + 1,
  Component: ItemComponent,
  values: current,
  classes: classes
}));
export default RepeatedItems;
//# sourceMappingURL=RepeatedItems.js.map